import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle, XCircle } from "lucide-react";
import api from "../lib/api";

export default function AutoLoginPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState("loading");
    const [error, setError] = useState("");
    const token = searchParams.get("token");

    useEffect(() => {
        if (!token) { setStatus("error"); setError("Chybí přihlašovací token"); return; }
        api.get(`/b2b-autologin/${token}`)
            .then(r => {
                const d = r.data;
                localStorage.setItem("sg_customer_token", d.token);
                localStorage.setItem("sg_customer_user", JSON.stringify({ name: d.name, email: d.email, id: d.id }));
                setStatus("success");
                setTimeout(() => navigate("/muj-ucet"), 1500);
            })
            .catch(e => {
                setStatus("error");
                setError(e.response?.data?.detail || "Neplatný nebo expirovaný odkaz");
            });
    }, [token, navigate]);

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-testid="auto-login-page">
            <div className="w-full max-w-sm text-center">
                {status === "loading" && (
                    <div>
                        <Loader2 size={48} className="mx-auto mb-4 text-brand-600 animate-spin" />
                        <h1 className="text-xl font-heading font-bold text-gray-900">Přihlašuji vás...</h1>
                        <p className="text-sm text-gray-500 mt-2">Počkejte prosím</p>
                    </div>
                )}
                {status === "success" && (
                    <div>
                        <CheckCircle size={48} className="mx-auto mb-4 text-green-600" />
                        <h1 className="text-xl font-heading font-bold text-gray-900">Přihlášení úspěšné</h1>
                        <p className="text-sm text-gray-500 mt-2">Přesměrováváme vás do účtu...</p>
                    </div>
                )}
                {status === "error" && (
                    <div>
                        <XCircle size={48} className="mx-auto mb-4 text-red-500" />
                        <h1 className="text-xl font-heading font-bold text-gray-900">Přihlášení selhalo</h1>
                        <p className="text-sm text-red-500 mt-2">{error}</p>
                        <button onClick={() => navigate("/prihlaseni")} className="mt-4 text-sm text-brand-700 underline">
                            Přihlásit se ručně
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
